module.exports = __webpack_public_path__ + "media/images/mail_about-03b081c56d60b12f837a1e952309d92a.svg";